function applyThemeFromLocalStorage() {
  // Retrieve the theme from localStorage
  var ldTheme = localStorage.getItem('ldSwitch');
  var systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  var selectedIcon = 2; // Default to system icon (auto mode)
  var themeToApply = 'system'; // Default data-theme

  // If no theme is stored, set to system preference and use default data-theme
  if (!ldTheme) {
    ldTheme = 'system'; // Set to system preference by default
    localStorage.setItem('ldSwitch', ldTheme);
    localStorage.setItem('ldSwitchIcon', selectedIcon);
    themeToApply = systemPrefersDark ? 'dark' : 'default'; // Apply system preference
  } else {
    // If a theme is stored, set icon and theme accordingly
    if (ldTheme === 'dark') {
      selectedIcon = 1; // Moon icon for dark mode
      themeToApply = 'dark'; // Set theme to dark
    } else if (ldTheme === 'default') {
      selectedIcon = 0; // Sun icon for light mode (default)
      themeToApply = 'default'; // Set theme to default
    } else if (ldTheme === 'system') {
      selectedIcon = 2; // System icon for auto mode
      themeToApply = systemPrefersDark ? 'dark' : 'default'; // Apply system preference
    }
    localStorage.setItem('ldSwitchIcon', selectedIcon); // Update local storage with the selected icon
  }

  // Apply the theme to the HTML element
  document.getElementsByTagName('html')[0].setAttribute('data-theme', themeToApply);

  // Set the correct option in the select element
  var selectElement = document.getElementById('select-color-theme');
  if (selectElement) {
    selectElement.selectedIndex = selectedIcon; // Set to the corresponding option
  }

  // Set the correct icon in the switcher
  var switcher = document.querySelector('.js-ld-switch');
  if (switcher) {
    var icons = switcher.getElementsByClassName('js-ld-switch-icon');
    if (icons.length > selectedIcon) {
      for (var i = 0; i < icons.length; i++) {
        icons[i].classList.remove('ld-switch-btn__icon-wrapper--in');
      }
      icons[selectedIcon].classList.add('ld-switch-btn__icon-wrapper--in');
    }
  }
}
applyThemeFromLocalStorage();

import { initLightDarkSwitchEx } from './components/_3_light-dark-switch.js';

document.addEventListener('DOMContentLoaded', function() {
  initLightDarkSwitchEx();
});

function alignRows() {
	const labels = document.querySelectorAll('.labels .row');
	const pressable = document.querySelectorAll('.pressable .row');
	const wpengine = document.querySelectorAll('.wpengine .row');
	const isDesktop = window.innerWidth >= 768; // Check if the screen is desktop size

	// Reset all row heights to 'auto' for a fresh calculation
	pressable.forEach(row => row.style.height = 'auto');
	wpengine.forEach(row => row.style.height = 'auto');
	labels.forEach(row => row.style.height = 'auto');

	const rowCount = Math.max(labels.length, pressable.length, wpengine.length);

	for (let i = 0; i < rowCount; i++) {
		const labelRow = labels[i];
		const pressableRow = pressable[i];
		const wpengineRow = wpengine[i];

		if (isDesktop) {
			// On desktop, include the labels column in the height calculation
			const maxHeight = Math.max(
				labelRow ? labelRow.offsetHeight : 0,
				pressableRow ? pressableRow.offsetHeight : 0,
				wpengineRow ? wpengineRow.offsetHeight : 0
			);

			// Set all rows to the maximum height
			if (labelRow) labelRow.style.height = maxHeight + 'px';
			if (pressableRow) pressableRow.style.height = maxHeight + 'px';
			if (wpengineRow) wpengineRow.style.height = maxHeight + 'px';

		} else {
			// On mobile, ignore the labels column and only check the other two
			const maxHeight = Math.max(
				pressableRow ? pressableRow.offsetHeight : 0,
				wpengineRow ? wpengineRow.offsetHeight : 0
			);

			// Set only the pressable and wpengine rows to the maximum height
			if (pressableRow) pressableRow.style.height = maxHeight + 'px';
			if (wpengineRow) wpengineRow.style.height = maxHeight + 'px';
		}
	}
}

// Call alignRows on load and when resizing the window
window.addEventListener('load', alignRows);
window.addEventListener('resize', alignRows);